export default __webpack_public_path__ + "static/media/action-arrow-down.c9095e1b.svg";